const AUTH_HAD_SESSION_KEY = "auth-had-session";

export const authHadSession = {
  read(): "1" | "superuser" | false {
    if (typeof window === "undefined") return false;
    try {
      const value = window.localStorage.getItem(AUTH_HAD_SESSION_KEY);
      return value === "1" || value === "superuser" ? value : false;
    } catch {
      return false;
    }
  },
  write(user: { is_superuser: boolean }): void {
    try {
      window.localStorage.setItem(
        AUTH_HAD_SESSION_KEY,
        user.is_superuser ? "superuser" : "1",
      );
    } catch {
      // Storage may be unavailable in restricted browser contexts.
    }
  },
  clear(): void {
    try {
      window.localStorage.removeItem(AUTH_HAD_SESSION_KEY);
    } catch {
      // ignore
    }
  },
};
